import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon.jsx';

const { FiBook, FiShield, FiZap } = FiIcons;

const Benefits = () => {
  const benefits = [
    {
      icon: FiBook,
      title: "Embasamento Teórico",
      text: "Você terá embasamentos teóricos e práticos necessários ao cuidado do seu filho seja ele criança ou pré adolescente para garantir o melhor desenvolvimento emocional que ele merece."
    },
    {
      icon: FiShield,
      title: "Segurança e Confiança",
      text: "Você vai entender, de uma vez por todas, como cuidar do seu filho com segurança e confiança, usando o que há de mais moderno e comprovado pela ciência."
    },
    {
      icon: FiZap,
      title: "Abordagens Científicas",
      text: "O conteúdo reúne as principais abordagens da psicologia — Terapia Cognitivo-Comportamental, Teoria do Apego, Terapia do Esquema e Análise do Comportamento — além de explicar, de forma prática, como a personalidade é construída e quais fatores influenciam esse desenvolvimento, para que você saiba exatamente como agir no dia a dia."
    }
  ];

  return (
    <section id="benefits" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-black text-[#2c3a50] uppercase tracking-tight">
            COM O SEMENTINHA VOCÊ:
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <motion.div 
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              viewport={{ once: true }}
              className="p-8 rounded-3xl bg-gray-50 border border-gray-100 hover:border-[#c5a059] transition-all group flex flex-col"
            >
              <div className="w-14 h-14 bg-[#2c3a50] rounded-2xl flex items-center justify-center mb-6 shadow-lg group-hover:bg-[#c5a059] transition-colors shrink-0">
                <SafeIcon icon={benefit.icon} className="w-7 h-7 text-white" />
              </div>
              <h3 className="text-xl font-bold text-[#2c3a50] mb-4 uppercase tracking-tighter">{benefit.title}</h3>
              <p className="text-gray-600 leading-relaxed text-sm flex-grow">{benefit.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Benefits;